import React from "react";
import { useNavigate } from "react-router-dom";
import QuestionSelector from "../components/home/QuestionSelector";
import FrontPageQuestionSelectorText from "../components/home/FrontPageQuestionSelectorText";
import Button from "../components/general/inputs/Button";
import classes from "./Home.module.css";
import VideoButton from "../components/general/VideoButton";
import HomeVideo from "../assests/videos/2_Home_Page.mp4";

const HomePage = () => {
  const navigate = useNavigate();

  const goToYourDetails = (event) => {
    navigate("/yourdetails");
  };

  const goToTC = (event) => {
    navigate("/T&Cs");
  };

  return (
    <div>
      <VideoButton videoTitle="Home Page" video={HomeVideo} />
      <h2> Welcome to the Northern Ireland Civil Service Pension Scheme Partial 
        Retirement Remedy Benefits Illustrator </h2>
      <p>
        {" "}
        This illustrator is intended for members affected by the 2015 
        Remedy (McCloud) who are considering partial retirement. The illustrator is
        designed to provide these members with an overview of how different
        choices may impact their salary and pension benefits at partial
        retirement and at full retirement.
      </p>
      <h2>About partial retirement</h2>
      <p>
        Partial retirement allows active pension scheme members to take some or
        all of their pension and tax-free lump sum and continue working. Members
        can take up to 100% of their pension benefits when they partially
        retire. There are particular conditions that need to be met in order for
        you to take partial retirement, for example you must be over a certain
        minimum age and your pay should be reduced by at least 20%. You can find
        out more about partial retirement at{" "}
        <a
          href="https://www.finance-ni.gov.uk/articles/partial-retirement"
          target="_blank"
        >
          https://www.finance-ni.gov.uk/articles/partial-retirement
        </a>
        .
      </p>{" "}
      <p>
        Partial retirement may involve making your Remedy choice. This will
        affect the partial retirement benefits you receive and also the
        projected benefits at your full retirement. Your Remedy choice will be
        final and irrevocable and any Remedy choice made at partial retirement
        will also apply to your benefits at full retirement.
      </p>{" "}
      <p>
        Some members contribute to the Partnership scheme, a separate defined
        contribution scheme. Partial retirement is not relevant to the
        Partnership scheme.
      </p>{" "}
      <h2>
        Click on the buttons below to find out more about partial retirement and
        this illustrator.
      </h2>
      <QuestionSelector items={FrontPageQuestionSelectorText} />
      <h2> How to use the illustrator and limitations </h2>
      <p>
        {" "}
        For the best experience the Partial Retirement Illustrator should be
        completed on a desktop computer. Whilst the illustrator is mobile phone
        / tablet compatible, there may be compatibility issues on some models.
      </p>{" "}
      <p>
        We have provided guidance videos on each page to assist you on your
        journey through the illustrator. Please note that these videos might not
        play on certain work setups due to their security configurations. If
        this is the case, please try accessing from a personal device.
      </p>{" "}
      <p>
        The T&Cs tab sets out the Terms & Conditions for the use of this
        illustrator, and details of the approach underlying the illustrator’s
        projections. Please ensure you read this before proceeding with use of
        the illustrator. By using this illustrator, you agree that you have read
        and understood the Terms & Conditions, and you accept the approaches and
        approximations used in this illustrator and any limitations this may
        have on the results.
      </p>{" "}
      <p>
        This illustrator will not check your information against other systems.
        If you enter inaccurate information, the output will be of limited
        value. No data you enter into this illustrator is stored or otherwise
        processed.
      </p>{" "}
      <p>
        This illustrator is for guidance and illustration purposes only. The
        illustrator is designed to provide a basic illustration of your
        projected benefits at partial retirement and full retirement from both
        your legacy scheme and alpha.
      </p>
      <p>
        For the comparison to make sense, we need to project your benefits.
        Therefore, the figures we show will not be as shown in your Annual
        Benefit Statement.
      </p>{" "}
      <p>
        Where we project benefits in this illustrator, we present figures in
        “today's money terms”. However, we do offer you the ability to switch to
        nominal terms. Nominal terms will show the value of lump sum and pension
        in terms of monetary amounts at the time of payment. “Today’s money
        terms” means the nominal value adjusted for inflation and therefore will
        represent what the pension would be worth today, i.e. so you can compare
        it with your income today and what you expect to need in retirement.
      </p>{" "}
      <p>
        The scheme guides will help you understand your benefits:{" "}
        <a
          href="https://www.finance-ni.gov.uk/articles/nics-pension-schemes-members-publications"
          target="_blank"
        >
          https://www.finance-ni.gov.uk/articles/nics-pension-schemes-members-publications
        </a>
      </p>{" "}
      <p>
        This illustrator is suitable for use by members who originally received
        transitional protection. Transitional protection is now superseded by
        the Remedy. You can find out more here:{" "}
        <a
          href="https://www.finance-ni.gov.uk/articles/mccloud-judgment-and-2015-remedy"
          target="_blank"
        >
          https://www.finance-ni.gov.uk/articles/mccloud-judgment-and-2015-remedy
        </a>
      </p>{" "}
      <div className={classes.button_container}>
        <Button onClick={goToTC}>Go to T&Cs</Button>
        <Button onClick={goToYourDetails}>
          Start Partial Retirement Remedy Benefits Illustrator
        </Button>
      </div>
    </div>
  );
};

export default HomePage;
